export default function nestChildren(flatArr, include_count = false) {
    const flat = flatArr.map(cld => (Object.assign({}, cld)));
    function checkLeftOvers(leftOvers, possibleParent) {
        for (let i = 0; i < leftOvers.length; i++) {
            if (leftOvers[i].parentId === possibleParent.id) {
                delete leftOvers[i].parentId;
                possibleParent.children ? possibleParent.children.push(leftOvers[i]) : possibleParent.children = [leftOvers[i]];
                if (include_count) {
                    possibleParent.count = possibleParent.children.length;
                }
                const addedObj = leftOvers.splice(i, 1);
                checkLeftOvers(leftOvers, addedObj[0]);
            }
        }
    }
    function findParent(possibleParents, possibleChild) {
        let found = false;
        for (let i = 0; i < possibleParents.length; i++) {
            if (possibleParents[i].id === possibleChild.parentId) {
                found = true;
                delete possibleChild.parentId;
                if (possibleParents[i].children)
                    possibleParents[i].children.push(possibleChild);
                else
                    possibleParents[i].children = [possibleChild];
                if (include_count)
                    possibleParents[i].count = possibleParents[i].children.length;
                return true;
            }
            else if (possibleParents[i].children)
                found = findParent(possibleParents[i].children, possibleChild);
        }
        return found;
    }
    const nested = flat.reduce((initial, value, index, original) => {
        if (value.parentId === null) {
            if (initial.left.length)
                checkLeftOvers(initial.left, value);
            delete value.parentId;
            value.root = true;
            initial.nested.push(value);
        }
        else {
            let parentFound = findParent(initial.nested, value);
            if (parentFound)
                checkLeftOvers(initial.left, value);
            else
                initial.left.push(value);
        }
        return index < original.length - 1 ? initial : initial.nested;
    }, { nested: [], left: [] });
    return nested;
}
export function nestCategories(categories) {
    const nestedCategories = {};
    categories.forEach(category => {
        if (!nestedCategories[category.id]) {
            nestedCategories[category.id] = Object.assign(Object.assign({}, category), { children: [] });
        }
        if (category.parentId) {
            if (!nestedCategories[category.parentId]) {
                nestedCategories[category.parentId] = { children: [] };
            }
            nestedCategories[category.parentId].children.push(nestedCategories[category.id]);
        }
    });
    return Object.values(nestedCategories).filter(category => !category.parentId);
}
